<template>
    <div @click.stop>
        <button
                class="btn btn-sm btn-default"
                type="submit"
                name="submit"
                value="pending_close"
                :disabled="disabled"
        >
            Complete Closing
        </button>
        <label for="closing_date">
            {{ label }}
        </label>
        <input 
            id="closing_date" 
            type="date" 
            class="btn btn-sm btn-default" 
            placeholder="YYYY-MM-DD" 
            name="closing_date" 
            :max="maxDates()" 
            @change="onChange($event)" 
            @click.stop
            v-model="close_date"
        />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                label : 'Closing Date',
                disabled : true,
                close_date : ''
            }
        },
        methods : {
            onChange(event) {
                this.close_date = event.target.value;
                if(this.close_date !== '') {
                    this.enableComplete();
                } else {
                    this.disableComplete();
                }
            },
            enableComplete() {
                    this.disabled = false;
            },
            disableComplete() {
                this.disabled = true;
            },
            maxDates() {
                let today = new Date();
                let day = today.getDate();
                let month = today.getMonth() + 1;
                let year = today.getFullYear();
                if(month < 10) month = '0' + month.toString();
                if(day < 10) day = '0' + day.toString();
                return year.toString()+'-'+month+'-'+day;
            },
        }
    }
</script>

<style scoped>

</style>